import React, { useState } from 'react'
import './StandardPage.scss'
import BackgroundImageMenu from '../BackgroundImageMenu/BackgroundImageMenu'
import ClientPhotoMenu from '../ClientPhotoMenu/ClientPhotoMenu'
import TextMenu from '../TextMenu/TextMenu'
import photoPlaceholder from '../../../../../../../assets/photo_placeholder.svg'
import RadioButtonsGroup from '../../../../../../commons/RadioButtonsGroup/RadioButtonsGroup'
import { useStateValue } from '../../../../../../../state/state'
import { serverURL } from '../../../../../../../config'
import { useTranslation } from 'react-i18next'


function StandardPage({
  pageNumber,
  handleImageChange,
}) {
  const [{ bookData }, dispatch] = useStateValue()
  const [openMenu, setOpenMenu] = useState(null) // backgroundImage, clientPhoto, text
  const [gender, setGender] = useState('boys')
  const { t } = useTranslation()
  const pageData = bookData.pages.find(page => page.number === pageNumber)
  
  const genderOptions = [
    { value: 'boys', label: t('pagesEditor.forBoys') },
    { value: 'girls', label: t('pagesEditor.forGirls') },
  ]

  const renderText = () => {
    if (gender === 'boys') return pageData.boysText || `${t('pagesEditor.textPlaceholder')}`
    if (gender === 'girls') return pageData.girlsText || `${t('pagesEditor.textPlaceholder')}`
  }

  const getImageSrc = (uploadedFile) => {
    if (uploadedFile.filePath) {
      return (serverURL + uploadedFile.filePath)
    } else {
      return window.URL.createObjectURL(uploadedFile)
    }
  }

  return (
    <div className="standard-page">
      <div className="page-menu">
        <div className="page-name">{t(`pageNames.${pageData.name}`)}</div>
        <div className="page-menu-item mt16">
          <BackgroundImageMenu 
            dragAndDropId={`drag-and-drop-page-${pageNumber}`}
            isMenuOpen={openMenu === 'backgroundImage'}
            handleMenuClick={setOpenMenu} 
            backgroundImage={pageData.backgroundImage}
            onChange={value => handleImageChange(value, pageData)}
          />
        </div>
        <div className="page-menu-item mt12">
          <ClientPhotoMenu 
            pageNumber={pageNumber}
            isMenuOpen={openMenu === 'clientPhoto'} 
            handleMenuClick={setOpenMenu} 
            position={pageData.clientPhotoPosition}
            onChange={value => dispatch({ type: 'setBookPageData', number: pageNumber, field: 'clientPhotoPosition', data: value})}
          />
        </div>
        <div className="page-menu-item mt12">
          <TextMenu 
            pageNumber={pageNumber}
            isMenuOpen={openMenu === 'text'} 
            handleMenuClick={setOpenMenu} 
            position={pageData.textPosition}
            boysText={pageData.boysText}
            girlsText={pageData.girlsText}
            onPositionChange={value => dispatch({ type: 'setBookPageData', number: pageNumber, field: 'textPosition', data: value})}
            onBoysTextChange={value => dispatch({ type: 'setBookPageData', number: pageNumber, field: 'boysText', data: value})}
            onGirlsTextChange={value => dispatch({ type: 'setBookPageData', number: pageNumber, field: 'girlsText', data: value})}
          />
        </div>
      </div>

      <div>
        <div className="page-content">
          {
            pageData.backgroundImage && <img src={getImageSrc(pageData.backgroundImage)} className="background-image" alt="background image" />
          }
          {
            pageData.clientPhotoPosition && pageData.clientPhotoPosition !== 0 
              ? <img src={photoPlaceholder} 
                alt="photo placeholder"
                className={`photo-placeholder ${
                  pageData.clientPhotoPosition === 1 && pageNumber % 2 == 0 ? 'right-page-top-left' : ''
                } ${  
                  pageData.clientPhotoPosition === 1 && pageNumber % 2 == 1 ? 'left-page-top-left' : ''
                } ${
                  pageData.clientPhotoPosition === 2 && pageNumber % 2 == 0 ? 'right-page-botton-left' : ''
                } ${  
                  pageData.clientPhotoPosition === 2 && pageNumber % 2 == 1 ? 'left-page-botton-left' : ''
                } ${
                  pageData.clientPhotoPosition === 3 && pageNumber % 2 == 0 ? 'right-page-top-right' : ''
                } ${
                  pageData.clientPhotoPosition === 3 && pageNumber % 2 == 1 ? 'left-page-top-right' : ''
                } ${
                  pageData.clientPhotoPosition === 4 && pageNumber % 2 == 0 ? 'right-page-botton-right' : ''
                } ${
                  pageData.clientPhotoPosition === 4 && pageNumber % 2 == 1 ? 'left-page-botton-right' : ''
                }`}
              />
              : null
          }
          {
            pageData.textPosition && pageData.textPosition !== 0
              ? <div
                dangerouslySetInnerHTML={{__html: renderText()}}
                className={`text ${
                  pageData.textPosition === 1 && pageNumber % 2 == 0 ? 'right-page-top-left' : ''
                } ${  
                  pageData.textPosition === 1 && pageNumber % 2 == 1 ? 'left-page-top-left' : ''
                } ${
                  pageData.textPosition === 2 && pageNumber % 2 == 0 ? 'right-page-botton-left' : ''
                } ${  
                  pageData.textPosition === 2 && pageNumber % 2 == 1 ? 'left-page-botton-left' : ''
                } ${
                  pageData.textPosition === 3 && pageNumber % 2 == 0 ? 'right-page-top-right' : ''
                } ${
                  pageData.textPosition === 3 && pageNumber % 2 == 1 ? 'left-page-top-right' : ''
                } ${
                  pageData.textPosition === 4 && pageNumber % 2 == 0 ? 'right-page-botton-right' : ''
                } ${
                  pageData.textPosition === 4 && pageNumber % 2 == 1 ? 'left-page-botton-right' : ''
                }`}
              />
              : null
          }
        </div>

        <div className="mt24">
          <RadioButtonsGroup
            label={t('pagesEditor.previewLabel')}
            name={`gender-page-${pageNumber}`}
            value={gender}
            options={genderOptions}
            error={null}
            onChange={value => setGender(value)}
          />
        </div>
      </div>
    </div>
  )
}

export default StandardPage
